import React from 'react';
import classnames from 'classnames';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux'
import store from '../../Redux';
import { doPost, doLoad, doPut, select, doDelete, apiUrlOpen, goBack, socket } from '../../Redux/Actions'

import Haltestellen from './Haltestellen'

import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import PrintIcon from '@material-ui/icons/Print';
import AddIcon from '@material-ui/icons/Add';
import TrainIcon from '@material-ui/icons/Train';
import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import Cached from '@material-ui/icons/Cached';
import SubdirectoryArrowLeft from '@material-ui/icons/SubdirectoryArrowLeft';
import SubdirectoryArrowRight from '@material-ui/icons/SubdirectoryArrowRight';
import LockIcon from '@material-ui/icons/Lock';
import LockOpen from '@material-ui/icons/LockOpen';

import Checkbox from '@material-ui/core/Checkbox';

import HistoryBackButton from '../../Components/HistoryBackButton';
import Loader from '../../Components/Loader';
import Master from '../../Components/Master';
import IconButton from '@material-ui/core/IconButton';
import Toolbar from '@material-ui/core/Toolbar';
import Divider from '@material-ui/core/Divider';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Portal from '@material-ui/core/Portal';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';

import LoaderButton from '../../Components/LoaderButton';
import { TextFieldHelper, SelectFieldWrapper, SwitchFieldWrapper, SelectFieldWrapperExtended, CheckboxFieldWrapper } from '../../Components/Fields';
import BackButton from '../../Components/BackButton';
import DatePickerContainer from '../../Components/DatePickerContainer';
import convertMinutesToString from '../../Components/convertMinutesToString';
import UmlaufplanAuswahl from '../../Components/UmlaufplanAuswahl';

import MaskedInput from 'react-text-mask';

function TextMaskCustom(props) {
    const { inputRef, ...other } = props;

    return (
        <MaskedInput
            {...other}
            ref={inputRef}
            mask={[/[0-9]/, /[0-9]/, ':', /[0-9]/, /[0-9]/]}
            placeholderChar={'0'}
            showMask
        />
    )
}

const styles = theme => ({
    flex: {
        flex: 1
    },
    card: {
        width: "100%"
    },
    haltestelleCell: {
        width: "250px"
    },
    slotCell: {
        width: "50px",
        paddingRight: "4px",
        textAlign: "center"
    },
    addCell: {
        //textAlign: "right"
    },
    maskedInput: {
        width: "50px",
        textAlign: "center"
    },
    tableCellFlex: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    svg: {
        marginRight: 20
    },
    paper: {
        marginTop: 20
    },
    divider: {
        marginTop: 20,
        marginBottom: 20,
        marginLeft: -30,
        marginRight: -30,
    },
    bigFont: {
        fontSize: 20,
        marginBottom: 5
    },
    alignCenter: {
        textAlign: "center"
    },
    direction: {
        marginTop: 20,
        display: "flex",
        justifyContent: "center"
    },
    progress: {
        padding: 20
    },
    colorDiv: {
        height: 15,
        boxShadow: "0 0 10px rgba(0,0,0,0.3)",
        borderRadius: "3px"
    }
})

const regex = /=z(\$|)([0-9]+)(\+|-|\*|\/)([0-9]+)/gm;

var FahrplanDialogForm = ({handleChange, disabled, farbzuordnung, farbe, data, classes}) => {
    return (
        <div>
            <Grid container spacing={8}>
                <SelectFieldWrapperExtended 
                    disabled={disabled}
                    n={2}
                    items={farbzuordnung && farbzuordnung.map((item) => (
                        {val: item.farbe, label: item.name, farbe: item.farbe}
                    ))}
                    name="Farbe"
                    value={data.farbe}
                    handleChange={handleChange('farbe')}
                />
                <TextFieldHelper disabled={disabled} n={1} value={data.paket} onChange={handleChange('paket')} label="Paket" />
                <TextFieldHelper disabled={disabled} n={1} value={data.nummer} onChange={handleChange('nummer')} label="Liniennummer" />
                <TextFieldHelper disabled={disabled} n={5} value={data.name} onChange={handleChange('name')} label="Name" />
                <Grid item xs={3}>
                        <Grid container spacing={8}>
                            <Grid item xs={6}>
                                <DatePickerContainer
                                    dateInput
                                    name="von"
                                    label="Gültig von"
                                    value={data.von}
                                    onChange={handleChange('von')}
                                    disabled={disabled}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <DatePickerContainer
                                    dateInput
                                    name="bis"
                                    label="Gültig bis"
                                    value={data.bis}
                                    onChange={handleChange('bis')}
                                    disabled={disabled}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
            </Grid>
        </div>
    )
}

var FahrplanDialogFormBottom = ({handleChange, disabled, verkehrshinweis, verkehrshinweisText, direction, farbe, data, classes}) => {
    return (
        <div>
            <Grid container spacing={8}>
                {direction === 0 && <TextFieldHelper disabled={disabled} n={12} value={data.befoerderungsbedingungen1} multiline onChange={handleChange('befoerderungsbedingungen1')} label="Fahrt 1: Beförderungsbedingungen" />}
                {direction === 1 && <TextFieldHelper disabled={disabled} n={12} value={data.befoerderungsbedingungen2} multiline onChange={handleChange('befoerderungsbedingungen2')} label="Fahrt 2: Beförderungsbedingungen" />}
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                {!verkehrshinweis || Object.keys(verkehrshinweis).length === 0 && <p><small>Es wurden noch keine <b>Verkehrshinweise</b> hinzugefügt.</small></p>}
                {verkehrshinweis && Object.keys(verkehrshinweis).map((key) => (
                    <Grid item xs={12} className="verkehrshinweisEingabe">
                        {verkehrshinweis[key].symbol}
                        <TextFieldHelper disabled={disabled} value={verkehrshinweisText[key] && verkehrshinweisText[key].text} onChange={handleChange("text", false, "verkehrshinweisText", key)} label={"Verkehrshinweis"} />
                    </Grid>
                ))}
            </Grid>
        </div>
    )
}

class FahrplanDetail extends Master {

    state = {
        tab: 0,
        newEntry: {},
        putLoading: false,
        isLoading: true,
        umlaufplan_isLoading: true,
        cols: [],
        rows: [],
        kurs: [],
        kilometer: [],
        direction: 0,
        showUmlauflaene: true,
        currentCol: undefined,
        enableFocusedCell: true,
        verkehrshinweisData: {},
        verkehrshinweisText: {},
        col_order: true,
        saveOnChange: true,
    }

    setFirstLast = (rows, firstLast) => {
        rows.forEach((row, index) => {
            Object.keys(row).forEach((key, i) => {
                if(key.indexOf("slot") === 0) {
                    var val = row[key]
                    if(index > 0) {
                        var valBefore = rows[index-1][key]
                        if(valBefore && valBefore[firstLast] && val.skip) {
                            rows[index][key][firstLast] = true
                        } else {
                            rows[index][key][firstLast] = false
                        }
                    } else {
                        if(val.skip) {
                            rows[index][key][firstLast] = true
                        } else {
                            rows[index][key][firstLast] = false
                        }
                    }
                }
            })
        })
        return rows
    }

    componentDidMount() {

        /*socket.on('umlaufplan_'+this.props.match.params.id, () => {
            this.props.farbzuordnung_doLoad()
            this.props.doLoad(this.props.match.params.id)
        });*/

        //socket.on('fahrplan_'+this.props.match.params.id, () => {
            //this.props.farbzuordnung_doLoad()
            //console.log("umlaufplan_", this.props.match.params.id)
            //this.props.doLoad(this.props.match.params.id)
        //});  

        this.props.doLoad(this.props.match.params.id, {direction: this.state.tab})
        this.props.umlafplan_doLoad()
        this.props.zeitraum_doLoad()
        this.props.verkehrshinweis_doLoad()
        this.props.farbzuordnung_doLoad()

        this.unsubscribe = store.subscribe(() => {
                var generic = select(store.getState(), "fahrplan")

                var verkehrshinweis = []
                var verkehrshinweisText = {}
                var kilometer = []
                var kurs = []
                var rows = []
                var cols = 0

                if(!_.isEmpty(generic.data.eintraege)) {

                    if(generic.data.eintraege !== this.eintraege) {

                        generic.data.eintraege.forEach((item, index) => {
                            if(_.isEmpty(rows[item.row])) {
                                rows[item.row] = {}
                            }
                            if(_.isEmpty(rows[item.row]["haltestelle"])) {
                                rows[item.row]["haltestelle"] = item.haltestelle
                            }
                            rows[item.row]["type"] = item.type
                            rows[item.row]["slot"+item.col] = item
                            if(item.col>cols) {
                                cols = item.col
                            }
                            kurs[item.col] = item.linienkursnummer
                            kilometer[item.col] = item.kilometer
                            if(item.verkehrshinweis_id) {
                                verkehrshinweis[item.verkehrshinweis_id] = item.verkehrshinweis
                            }
                        })
                        
                        this.setFirstLast(rows, "firstSkip")
                        _.reverse(rows)
                        this.setFirstLast(rows, "lastSkip")
                        _.reverse(rows)

                        if(generic.data.verkehrshinweis_text) {
                            generic.data.verkehrshinweis_text.forEach((item) => {
                                if(parseInt(item.direction) === this.state.tab) {
                                    verkehrshinweisText[item.verkehrshinweis_id] = item
                                }
                            })
                        }

                        this.setState({
                            cols: new Array(cols+1).fill(),
                            rows: rows,
                            kurs: kurs,
                            kilometer: kilometer ? kilometer : 0,
                            verkehrshinweis: verkehrshinweis,
                            verkehrshinweisText: verkehrshinweisText
                        })
                        
                        this.eintraege = generic.data.eintraege

                    }
                    
                } else {
                    this.setState({
                        cols: [],
                        rows: rows,
                        kurs: kurs,
                        kilometer: kilometer,
                    })
                    this.eintraege = undefined
                }

                if(this.state.newEntry !== generic.data || this.state.newEntry.id === undefined) {
                    this.setState({
                        newEntry: generic.data
                    })
                }

                if(this.state.isLoading) {
                    this.setState({
                        isLoading: generic.isLoading
                    })
                }

                if(_.has(generic, "putLoading") && this.state.putLoading !== generic.putLoading) {
                    if(_.has(generic.putLoading, this.state.newEntry.id)) {
                        this.setState({
                            putLoading: generic.putLoading[this.state.newEntry.id]
                        })
                    }
                }

                var generic = select(store.getState(), "generic")
                if(this.state.umlaufplan_isLoading) {
                    this.setState({
                        umlaufplan_isLoading: generic.isLoading,
                        showUmlauflaene: generic.dialogOpen
                    })
                }

            }
        )

    }

    componentWillUnmount() {
        this.unsubscribe()
    }

    saveAction = (colOrder) => {

        var cols = []
        var rowBefore = {}

        this.state.rows.forEach((row, index) => {

            var haltestelle = ""
            if(row["haltestelle"]!==undefined) {
                haltestelle = row["haltestelle"]
            }

            this.state.cols.forEach((i, col) => {

                var val = {}
                if(row["slot"+col] !== undefined) {
                    val = row["slot"+col]
                }

                val.direction = parseFloat(this.state.tab)
                val.haltestelle = haltestelle
                val.row = index
                val.col = col
                val.type = row.type

                var match = /([a-zA-Z\-]+|)([0-9]+)/gm.exec(this.state.kurs[col]);
                console.log("match", match[1], parseFloat(match[2]))
                val.linienkursnummer = parseFloat(match[2])

                //val.linienkursnummer = parseFloat(this.state.kurs[col])

                val.kilometer = parseFloat(this.state.kilometer[col])
                if(row === 0 && val.skip) {
                    val.firstSkip = true
                } else if(val.skip) {

                }

                cols.push(val)

            })

        })

        var verkehrshinweise = []
        for (var key in this.state.verkehrshinweis) {
            var data = this.state.verkehrshinweisText[key]
            if(data) {
                verkehrshinweise.push({
                    fahrplan_id:  this.state.newEntry.id,
                    verkehrshinweis_id: key,
                    direction: ""+this.state.tab,
                    text: data.text,
                    symbol: data.symbol,
                })
            }
        }

        this.state.newEntry.col_order = this.state.col_order

        if(colOrder !== undefined) {
            this.state.newEntry.col_order = colOrder
        }

        this.state.newEntry.verkehrshinweis_text = verkehrshinweise
        this.state.newEntry.eintraege = cols
        this.props.doPut(this.state.newEntry.id, this.state.newEntry)
        this.state.newEntry.reorder_from = 0
        this.state.newEntry.reorder_to = 0
        this.state.col_order = true
        
    }

    addSlot = (copyData) => {

        /*var max = 40
        if(this.state.newEntry.sonderfahrt) {
            max = 1
        }*/

        /*if(this.state.cols.length==max) {
            alert("Es sind keine weiteren Spalten möglich")
            return
        }*/

        this.state.cols.push({})

        var linienkursnummerNew = this.state.cols.length+9000
        this.state.kurs.push(linienkursnummerNew)

        var colsCount = this.state.cols.length
        this.state.rows.forEach((row, index) => {
            if(copyData !== undefined) {

                var oldVal = _.clone(row["slot"+copyData])
                oldVal.linienkursnummer = linienkursnummerNew
                oldVal.linienkursnummer_old = linienkursnummerNew
                oldVal.col = colsCount-1
                oldVal.old_col = colsCount-1
                oldVal.umlaufplan_id = ""
                oldVal.umlaufplan_kuerzel = ""
                oldVal.umlaufplan_color = ""
                oldVal.umlaufplan_timesort = ""
                oldVal.zeitraum = {}
                oldVal.zeitraum_id = ""
                console.log("oldVal", oldVal) 
                row["slot"+(colsCount-1)] = oldVal

                /*
                var copyCat = {
                    type: oldVal.type,
                    haltestelle: oldVal.haltestelle,
                    linienkursnummer: linienkursnummerNew,
                    col: colsCount-1,
                    row: oldVal.row,
                    direction: oldVal.direction,
                    zeitraum: {},
                    zeitraum_id: "",
                    verkehrshinweis: oldVal.verkehrshinweis,
                    umlaufplan_id: "",
                    umlaufplan_kuerzel: "",
                    umlaufplan_color: "",
                    umlaufplan_timesort: "",
                    raw: oldVal.raw,
                    value: oldVal.value,
                    skip: oldVal.skip,
                    empty: oldVal.empty,
                    f: oldVal.f,
                    fF: oldVal.fF,
                    fB: oldVal.fB,
                    fW: oldVal.fW,
                    fI: oldVal.fI,
                    firstSkip: oldVal.firstSkip,
                    lastSkip: oldVal.lastSkip,
                    verkehrshinweis_id: oldVal.verkehrshinweis_id,
                }
                row["slot"+(colsCount-1)] = copyCat
                */

            } else {
                row["slot"+(colsCount-1)] = {
                    type: row.type,
                    haltestelle: row.haltestelle,
                    row: index,
                    col: (colsCount-1),
                    raw: 0,
                    value: "00:00",
                    skip: row.type === "zug" ? true : false,
                    empty: false,
                    bias_copy: true
                }
            }
        })

        this.setState({
            cols: this.state.cols
        })

        //if(this.state.saveOnChange === undefined || this.state.saveOnChange === true) {
            this.saveAction()
        //}

    }

    convertMinutesToString = value => {
        return convertMinutesToString(value)
    }

    convertStringToIntHours = value => {
        var valueString = ""+parseInt(value)
        if(valueString.length < 4) {
            while (valueString.length < 4) {
                valueString = "0" + valueString
            }
        }
        var hours   = parseInt(valueString[0] + valueString[1])
        var minutes = parseInt(valueString[2] + valueString[3])
        return hours * 60 + minutes
    }

    appendToUmlaufplan = (umlaufplanId) => {
        //this.state.currentCol = Math.floor(this.state.currentCol / 2)
        this.props.umlafplan_doPost({
            col: this.state.currentCol,
            umlaufplan: umlaufplanId,
            fahrplan: this.state.newEntry.id,
            direction: this.state.tab
        })
        this.setState({
            umlaufplan_isLoading: true
        })
    }

    showDialog = (index) => {
        this.setState({
            currentCol: index,
            showUmlauflaene: true
        })
    }

    hideDialog = () => {
        this.setState({
            showUmlauflaene: false
        })
    }

    new_handleChangeRows = (row, column, value) => {

    }

    new_handleChangeHeader = (column, name) => {
        this.state.kurs[column] = name
    }

    new_handleConfirmHeader = (column, name) => {
        this.state.kurs[column] = name
        this.setState({})
        if(this.state.saveOnChange === undefined || this.state.saveOnChange === true) {
            this.saveAction()
        }
    }

    new_changeTime = (value, rowIndex, columnIndex, confirm) => {
        this.state.rows[rowIndex]["slot"+(columnIndex)] = {
            ...this.state.rows[rowIndex]["slot"+(columnIndex)],
            f: value.value,
            value: value.value
        }
        this.setState({
            rows: this.state.rows
        })
    }  

    new_changeTimeConfirm = (value, rowIndex, columnIndex) => {

        var data = {
            value: "",
            f: "",
            fF: false,
            fB: 0,
            fW: 0,
            raw: 0
        }

        const regex = /=z(\$|)([0-9]+)(\+|-|\*|\/)([0-9]+)/gm;
        var regexData = regex.exec(value.value)

        if(regexData !== null) {
            data.f = regexData[0]
            data.fF = regexData[1] !== "" ? true : false
            data.fB = parseFloat(regexData[2])
            data.fW = parseFloat(regexData[4])
            data.fO = parseFloat(regexData[3])
        } else {
            data.value = this.intToTime(value.value)
            data.raw = this.convertStringToIntHours(value.value.replace(":", ""))
        }

        this.state.rows[rowIndex]["slot"+(columnIndex)] = {
            ...this.state.rows[rowIndex]["slot"+(columnIndex)],
            ...data
        }

        this.state.col_order = false

        if(this.state.saveOnChange === undefined || this.state.saveOnChange === true) {
            this.saveAction()
        }

    }

    new_deleteRow = (row) => {
        var rows = []
        this.state.rows.forEach((r, key) => {
            if(key !== row) {
                rows.push(r)
            }
        })
        this.state.rows = rows
        this.setState({})
        if(this.state.saveOnChange === undefined || this.state.saveOnChange === true) {
            this.saveAction()
        }
    }

    new_delteColumn = (column) => {
            

        this.state.rows.forEach((row, idx) => {
            delete this.state.rows[idx]["slot"+column]
            Object.keys(row).forEach((key) => {
                if(key.includes("slot")) {
                    if(row[key].col > column) {
                        row[key].col -= 1
                        this.state.rows[idx]["slot"+row[key].col] = {
                            ...row[key],
                            col: 1
                        }
                    }
                }
            })
        }) 

        this.state.cols.splice(this.state.cols.length-1, 1)
        //this.setState({})
        if(this.state.saveOnChange === undefined || this.state.saveOnChange === true) {
            this.saveAction()
        }
    }

    new_skipColumn = (column, row, value, mass) => {
        if(mass[0] !== mass[1]) {
            var i = mass[0]
            while(i<=mass[1]) {
                if(this.state.rows[i]["slot"+column].type !== "zug") {
                    this.state.rows[i]["slot"+column].skip = value
                }
                this.state.rows[i]["slot"+column].empty = value
                i++
            }
        } else {
            if(this.state.rows[row]["slot"+column].type !== "zug") {
                this.state.rows[row]["slot"+column].skip = value
            }
            this.state.rows[row]["slot"+column].empty = value
        }
        if(this.state.rows[row]["slot"+column].type !== "zug") {
            this.state.rows[row]["slot"+column].skip = value
        }
        this.state.rows[row]["slot"+column].empty = value
        if(this.state.saveOnChange === undefined || this.state.saveOnChange === true) {
            this.saveAction()
        }
    }

    new_prepareRows = () => {

    }

    new_changeHaltestelle = (value, rowIndex, isLoading) => {
        if(this.state.rows[rowIndex] === undefined) {
            var rows = {type:"bus", isLoading: isLoading}
            this.state.cols.forEach((_, k) => {
                rows["slot"+k] = {
                    value: "00:00",
                    raw: 0,
                    bias: 0,
                    bias_copy: true,
                    direction: parseFloat(this.state.tab),
                    isLoading: isLoading
                }
            })
            this.state.rows.push(rows)
        }
        this.state.rows[rowIndex]["haltestelle"] = value
    }

    new_changeHaltestelleConfirm = (value, rowIndex) => {
        this.new_changeHaltestelle(value, rowIndex, true)
        this.setState({})
        this.new_prepareRows()
        if(this.state.cols.length === 0) {
            this.addSlot()
        }
        if(this.state.saveOnChange === undefined || this.state.saveOnChange === true) {
            this.saveAction()
        }
    }

    new_changeKilometer = (value, columnIndex) => {
        if(value === undefined) return
            value = (""+value).replace(",", ".")
        this.state.kilometer[columnIndex-1] = parseFloat(value)
    }

    new_changeKilometerConfirm = (value, columnIndex) => {
        value = (""+value).replace(",", ".")
        this.new_changeKilometer(value, columnIndex)
        if(this.state.saveOnChange === undefined || this.state.saveOnChange === true) {
            if(this.state.saveOnChange === undefined || this.state.saveOnChange === true) {
                this.saveAction()
            }
        }
    }

    new_onRowsReordered = (oldIndex, newIndex, length) => {

        if(oldIndex === newIndex) {
            return
        }

        var from_value = this.state.rows[oldIndex]
        var to_value = this.state.rows[newIndex]

        var rows = []
        this.state.rows.forEach((row, idx) => {
            if(idx === oldIndex) {
                return
            }
            if(idx === newIndex) {
                rows.push(from_value)
            }
            rows.push(row)
        })

        this.state.rows = rows

        this.new_prepareRows()

        this.state.newEntry.reorder_from = oldIndex
        this.state.newEntry.reorder_to = newIndex

        //setTimeout(() => console.log("save"), 3000)
        this.state.newEntry.col_order = false
        //if(this.state.saveOnChange === undefined || this.state.saveOnChange === true) {
            this.saveAction()
        //}

    }

    new_onColumnsReordered = (oldIndex, newIndex, length) => {

        /*if(oldIndex === 1) {
            alert("Die erste Spalte kann nicht verschoben werden")
            return
        }*/

        oldIndex = oldIndex - 1
        newIndex = newIndex - 1

        var rows = _.clone(this.state.rows)

        this.state.rows.forEach((row, index) => {

            var from_value = _.clone(this.state.rows[index]["slot"+oldIndex])

            var max = 0
            Object.keys(row).forEach((item) => {
                if(item.includes("slot")) {
                    max++
                }
            })

            rows[index] = {}
            Object.keys(row).forEach((item) => {
                
                if(!item.includes("slot")) {
                    rows[index][item] = _.clone(row[item])
                    return
                }

                var val = _.clone(row[item])

                if(oldIndex > newIndex) {
                    if(val.col > oldIndex) {
                        rows[index]["slot"+val.col] = val
                    }

                    if(val.col <= newIndex) {
                        rows[index]["slot"+val.col] = val
                    }
                    
                    if(val.col >= newIndex && val.col < oldIndex) {
                        val.col += 1 
                        this.state.rows[index]
                        rows[index]["slot"+val.col] = {
                            ...val,
                            col: val.col
                        }
                    }
                } else {
                    if(val.col < oldIndex) {
                        rows[index]["slot"+val.col] = val
                    }

                    if(val.col >= newIndex) {
                        rows[index]["slot"+val.col] = val
                    }
                    
                    if(val.col <= newIndex && val.col > oldIndex) {
                        val.col -= 1 
                        this.state.rows[index]
                        rows[index]["slot"+val.col] = {
                            ...val,
                            col: val.col
                        }
                    }
                }
                

            })

            //from_value.umlaufplanId = ""

            rows[index]["slot"+newIndex] = {
                ...from_value,
                col: newIndex
            }

        })

        this.state.rows = rows

        this.state.rows.forEach((row, index) => {
            Object.keys(row).forEach((item) => {
                if(!item.includes("slot")) {
                    return
                }
                var val = row[item]
                this.state.kurs[val.col] = val.linienkursnummer
                this.state.kilometer[val.col] = val.kilometer
            })
            return
        })        

        this.setFirstLast(this.state.rows, "firstSkip")
        _.reverse(this.state.rows)
        this.setFirstLast(this.state.rows, "lastSkip")
        _.reverse(this.state.rows)

        this.state.newEntry.col_order = true
        //if(this.state.saveOnChange === undefined || this.state.saveOnChange === true) {
            this.saveAction()
        //}

    }

    changeType = (row, type) => {
        this.state.rows[row].type = type
        if(type !== "bus") {
            Object.keys(this.state.rows[row]).forEach((key, colN) => {
                if(key.includes("slot")) {
                    this.state.rows[row][key].type = type
                    this.state.rows[row][key].skip = true
                }
            })
            this.state.rows[row].skip = true
        } else {
            Object.keys(this.state.rows[row]).forEach((key, colN) => {
                if(key.includes("slot")) {
                    this.state.rows[row][key].type = type
                    this.state.rows[row][key].skip = false
                }
            })
            this.state.rows[row].skip = false
        }
        if(this.state.saveOnChange === undefined || this.state.saveOnChange === true) {
            this.saveAction()
        }
    }

    handleClickAway = (val) => {
        if(this.state.enableFocusedCell === val) {
            return
        }
        this.setState({
            enableFocusedCell: val
        })
    }

    addZeitraum = (key, column, row, item, remove) => {
        this.state.rows.forEach((row, index) => {
            if(remove) {
                this.state.rows[index]["slot"+column][key] = {}
                this.state.rows[index]["slot"+column][key+"_id"] = ""
            } else {
                this.state.rows[index]["slot"+column][key] = item
            }
        })
        if(this.state.saveOnChange === undefined || this.state.saveOnChange === true) {
            this.saveAction()
        }
    }

    tabChange = (event, value) => {
        this.eintraege = {}
        this.props.doLoad(this.props.match.params.id, {direction: value})
        this.setState({ tab: value });
    }

    copyFormular = (formel, region, column) => {
        var regexData = regex.exec(formel)

        if(regexData) {
            var rowWert = parseFloat(regexData[2])
            var i = region[0]
            while(i<=region[1]) {
                var newFormel = _.clone(regexData)
                delete newFormel[0]
                if(regexData[1] == "") {
                    newFormel[2] = rowWert
                }
                this.state.rows[i]["slot"+column].f = "=z"+newFormel.join("")
                rowWert++
                i++
            }
        }
        
        if(this.state.saveOnChange === undefined || this.state.saveOnChange === true) {
            this.saveAction()
        }
    }

    duplicateKurs = (column) => {
        this.addSlot(column)
    }

    render() {

        var {
            classes, umlaufplan, farbzuordnung, fahrplan
        } = this.props

        var state = this.state

        var {
            tab, enableFocusedCell, kilometer, cols, rows, isLoading, newEntry, direction, umlaufplan_isLoading, showUmlauflaene, verkehrshinweis, verkehrshinweisData, verkehrshinweisText
        } = this.state

        if(isLoading) {
            return (
                <Loader />
            )
        }

        var goBack = "/fahrplan"
        if(newEntry.sonderfahrt) {
            goBack += "?sonderfahrten=true"
        }

        var kurs = []
        if(rows.length > 0) {
            Object.keys(rows[0]).forEach((key) => {
                var item = rows[0][key]
                if(item.col !== undefined) {
                    kurs[item.col] = item.linienkursnummer
                }
            })
        }

        //console.log("rerender", kurs, cols, rows[0])

        return (
            <div>

                {showUmlauflaene&&<UmlaufplanAuswahl key={"u"+showUmlauflaene} open={showUmlauflaene} hide={this.hideDialog} classes={classes} auswahl={this.appendToUmlaufplan} umlaufplaene={umlaufplan.data} loading={umlaufplan.isLoading} />}
                
                    <Toolbar>
                        <BackButton noEsc go={() => this.props.history.push(goBack)} />
                        <Typography variant="h1">
                            {newEntry.nummer} {newEntry.nummer && " - "} {newEntry.name} 
                        </Typography>
                        <div className={classes.flex} />
                        <IconButton aria-label="Delete">
                            <DeleteForeverIcon />
                        </IconButton>
                        <IconButton onClick={() => this.props.print(newEntry.id)}>
                            <PrintIcon />
                        </IconButton>
                    </Toolbar>

                    <Card className={classes.card}>
                        {newEntry.farbe && <div className={classes.colorDiv} style={{backgroundColor: newEntry.farbe}}></div>}
                        <CardContent>
                            <FahrplanDialogForm disabled={newEntry.lock} farbzuordnung={farbzuordnung.data} classes={classes} handleChange={this.handleChange} data={this.state.newEntry} />
                        </CardContent>
                        <CardActions className="cardAction">
                            <LoaderButton disabled={this.state.newEntry.lock} icon="save" name="Speichern" color="primary" onClick={() => this.saveAction(false)} loading={this.state.putLoading} />
                            {!this.state.newEntry.lock && fahrplan.past.length > 0 && <HistoryBackButton doReverse={this.props.history_goBack} data={fahrplan.past} />}
                            <Button disabled={this.state.newEntry.lock} size="small" variant="raised" color="primary" onClick={() => this.addSlot()}><AddIcon className="marginRight" />Neuer Kurs</Button>

                            <Button size="small" variant="raised" onClick={() => this.lock()}>{newEntry.lock ? <div className="alignCenter" ><LockOpen className="marginRight" />Entsperren</div> : <div className="alignCenter" ><LockIcon className="marginRight" />Sperren</div>}</Button>
                        </CardActions>
                    </Card>

                    <Grid container spacing={0}>
                        <Grid style={{display:"flex", alignItems:"flex-end"}} item xs={4}>
                            <Tabs value={tab} onChange={this.tabChange}>
                                <Tab label="1. Fahrt" />
                                <Tab label="2. Fahrt" />
                            </Tabs>
                        </Grid>
                        <Grid item xs={8}>
                            <p>
                                {tab === 0 && <TextFieldHelper disabled={newEntry.lock} n={12} value={this.state.newEntry.fahrplanname} onChange={this.handleChange('fahrplanname')} label="Fahrt 1: Fahrplanname" />}
                                {tab === 1 && <TextFieldHelper disabled={newEntry.lock} n={12} value={this.state.newEntry.fahrplanname_rueckfahrt} onChange={this.handleChange('fahrplanname_rueckfahrt')} label="Fahrt 2: Fahrplanname" />}
                            </p>
                        </Grid>
                    </Grid>
                    {this.props.fahrplan.isLoading && <Loader />}
                    <div key={tab+"haltestelle"}>
                        
                        <Haltestellen

                            disabled={newEntry.lock}
                            
                            onRowsReordered={this.new_onRowsReordered}
                            onColumnsReordered={this.new_onColumnsReordered}

                            handleConfirmHeader={this.new_handleConfirmHeader}
                            handleChangeHeader={this.new_handleChangeHeader}

                            skipColumn={this.new_skipColumn}
                            deleteRow={this.new_deleteRow}
                            delteColumn={this.new_delteColumn}

                            changeType={this.changeType}

                            showDialog={this.showDialog}
                                
                            changeKilometer={this.new_changeKilometer}
                            changeKilometerConfirm={this.new_changeKilometerConfirm}

                            changeHaltestelle={this.new_changeHaltestelle}
                            changeHaltestelleConfirm={this.new_changeHaltestelleConfirm}

                            changeTimeConfirm={this.new_changeTimeConfirm}
                            changeTime={this.new_changeTime}

                            direction={tab}
                            rows={rows}
                            cols={cols}
                            kurs={kurs}
                            kilometer={kilometer}

                            data={this.state.newEntry}

                            verkehrshinweis={this.props.verkehrshinweis.data}
                            addVerkehrshinweis={this.addVerkehrshinweis}
                            copyFormular={this.copyFormular}
                            duplicateKurs={this.duplicateKurs}

                            zeitraum={this.props.zeitraum.data}
                            addZeitraum={this.addZeitraum}

                            gotoTo={(url) => this.gotoTo(url, true)}

                        />
                    </div>

                    <div>
                        <Checkbox disabled={this.state.newEntry.lock} checked={state.saveOnChange} onChange={() => this.setState({saveOnChange: !state.saveOnChange})} value="Automatische Speichern deaktivieren" /> Automatisches Speichern aktivieren
                    </div>

                    <Card className={classnames(classes.card, "marginTop")}>
                        <CardContent>
                            <FahrplanDialogFormBottom disabled={newEntry.lock} key={tab+"FahrplanDialogFormBottom"} direction={tab} verkehrshinweis={verkehrshinweis} verkehrshinweisText={verkehrshinweisText} classes={classes} handleChange={this.handleChange} data={this.state.newEntry} />
                        </CardContent>
                        <CardActions className="cardAction">
                            <LoaderButton disabled={newEntry.lock} icon="save" name="Speichern" color="primary" onClick={() => { this.saveAction(false) }} loading={this.state.putLoading} />
                        </CardActions>
                    </Card>

            </div>
        )
    }
}

const mapStateToProps = state => ({
    fahrplan: state.fahrplan,
    umlaufplan: state.umlaufplan,
    zeitraum: state.zeitraum,
    verkehrshinweis: state.verkehrshinweis,
    farbzuordnung: state.farbzuordnung,
})

const mapDispatchToProps = (dispatch, ownProps) => ({

    history_goBack: (key) => dispatch(goBack("fahrplan",key)),

    doLoad: (id, filter) => dispatch(doLoad("fahrplan", "api/generic/fahrplan/single/"+id, filter)),
    doDelete: (id) => dispatch(doDelete("fahrplan", "api/generic/fahrplan/"+id, id)),
    doPut: (id, data) => dispatch(doPut("fahrplan", "api/generic/fahrplan/"+id, data)),
    print: (id) => dispatch(apiUrlOpen("api/pdf/fahrplan/"+id)),

    zeitraum_doLoad: (data) => dispatch(doLoad("zeitraum", "api/generic/zeitraum/list", data)),
    verkehrshinweis_doLoad: (data) => dispatch(doLoad("verkehrshinweis", "api/generic/verkehrshinweis/list", data)),
    umlafplan_doLoad: (data) => dispatch(doLoad("umlaufplan", "api/generic/umlaufplan/list", {alle: true, ...data})),
    farbzuordnung_doLoad: (data) => dispatch(doLoad("farbzuordnung", "api/generic/farbzuordnung/list", data)),
    
    umlafplan_doPost: (data) => dispatch(doPut("fahrplan", "api/kursToUmlaufplan", data)),

    //verkehrshinweisText_doLoad: (data) => dispatch(doLoad("verkehrshinweis", "api/generic/verkehrshinweis/list", data)),

})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(FahrplanDetail));



// WEBPACK FOOTER //
// ./src/Routes/Fahrplan/Detail.js